import React, { useEffect, useState } from "react";
import PageHeader from "../components/PagesHeaderComponent/PageHeader";
import { Button, Card, Col, Container, Modal, Row } from "react-bootstrap";
import { useNavigate } from "react-router-dom/dist";
import { Sec7, Sec8 } from "../components/Homecomponent";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUsers } from "@fortawesome/free-solid-svg-icons";
import PageHeaderWithRoutes from "../components/PagesHeaderComponent/PageHeaderWithRoute";
import ELearningIcon from "../../assets/images/icons/e_learning_icon.png"
import WebinarIcon from "../../assets/images/icons/webinar_icon.png"
import PresentationIcon from "../../assets/images/icons/presentation.png"
import PodcastIcon from "../../assets/images/icons/podcaster.png"
import ReportIcon from "../../assets/images/icons/report.png"
import InnerHeading from "../components/InnerHeading/InnerHeading";
import CoreHttpHandler from "../../http/services/CoreHttpHandler";
import moment from "moment";
import { Box, LinearProgress } from "@mui/material";
import { Button as AntButton, Dropdown, Input, Menu, Pagination } from "antd";
import ReactPlayer from "react-player";
import CustomTextLimit from "../../assets/global-components/TextLimit";

const WebinarsandEvents = () => {

	const navigate = useNavigate();


	const [data, setData] = useState([]);
	const [allData, setAllData] = useState([]);
	const [isLoading, setIsLoading] = useState(false);
	const [currentPage, setCurrentPage] = useState(1);
	const [activeTab, setActiveTab] = useState("Upcoming");
	const [modalShow, setModalShow] = useState(false);
	const [videoUrl, setVideoUrl] = useState("");

	const cleanYoutubeUrl = (url) => {
		if (!url) return url;
		try {
			const parsed = new URL(url);
			const videoId = parsed.searchParams.get("v");
			if (videoId && parsed.hostname.includes("youtube")) {
				return `https://www.youtube.com/watch?v=${videoId}`;
			}
		} catch (e) {}
		return url;
	};
	const [searchTitle, setSearchTitle] = useState("");
	const [selectedOrder, setSelectedOrder] = useState("ASC");
	const pageSize = 6;

	const getAllWebinarsnEvents = () => {
		setIsLoading(true)
		CoreHttpHandler.request(
			"shareholder_education",
			activeTab === "Upcoming" ?
				"fetchWebinarsnEvents"
				: "fetchArchiveWebinarsnEvents",
			{
				type: "webinar",
				status: "true",
				is_home: true,
				"limit": 10000,
				"page": 1
			},
			(res) => {
				setAllData(res?.data?.data?.shareholderss?.data)
				setIsLoading(false)
			},
			(err) => {
				setIsLoading(false)
			}
		);
	};

	const filterWebinarsEvents = () => {
		let filtered = allData;

		if (searchTitle) {
			filtered = filtered.filter(item =>
				item.title?.toLowerCase().includes(searchTitle.toLowerCase())
			);
		}

		const sorted = [...filtered].sort((a, b) =>
			selectedOrder === "ASC"
				? a.ordering - b.ordering
				: b.ordering - a.ordering
		);

		setData(sorted);
		setCurrentPage(1);
	};

	const handleOrderMenuClick = (e) => {
		setSelectedOrder(e.key);
	};

	const clearSearch = () => {
		setSearchTitle("");
		setSelectedOrder("ASC");
		setData(allData);
		setCurrentPage(1);
	};

	const orderMenu = (
		<Menu onClick={handleOrderMenuClick}>
			<Menu.Item key={"ASC"}>ASC</Menu.Item>
			<Menu.Item key={"DESC"}>DESC</Menu.Item>
		</Menu>
	);

	const paginatedData = data.slice(
		(currentPage - 1) * pageSize,
		currentPage * pageSize
	);


	useEffect(() => {
		getAllWebinarsnEvents();
	}, [activeTab])

	useEffect(() => {
		filterWebinarsEvents();
	}, [allData])

	const tabs = [
		{ name: "Upcoming" },
		{ name: "Archived" }
	];

	let headerData = [{
		name: "E - Learning",
		route: "/ShareHolderEducation/learning",
		imgSrc: ELearningIcon
	}, {
		name: "Webinars & Events",
		route: "/ShareHolderEducation/WebinarsandEvents",
		imgSrc: WebinarIcon
	}, {
		name: "Presentation",
		route: "/ShareHolderEducation/Presentation",
		imgSrc: PresentationIcon
	}, {
		name: "PICG\nPodcast",
		route: "/ShareHolderEducation/PICGPodcast",
		imgSrc: PodcastIcon
	}, {
		name: "Governance\nUpdate",
		route: "/ShareHolderEducation/GovernanceUpdate",
		imgSrc: ReportIcon
	}
	]
	return (
		<>
			{/* <PageHeader heading="Webinars and Events" /> */}
			<PageHeaderWithRoutes tabs={headerData} heading="Shareholder Education" desc="Explore our e-learning platform to discover diverse courses, access your student dashboard, and manage your enrollments. Register for upcoming webinars or catch up on past sessions with our archived videos to keep your learning journey on track." />

			<div className="content_wrap">
				<section className='sec sec8'>
					<div className='container'>
						<div className="cards_wrap">
							<Container>
								<Row>
									<InnerHeading heading="Webinars & Events" text="Register now to stay updated on our upcoming webinars, offering invaluable learning opportunities for shareholders. Dive into insightful sessions focused on educating shareholders about their rights and effective ways to exercise them." />

									<Col xs={12} style={{ animation: "fadeInUp 0.5s ease both" }}>
										<Row className="d-flex align-items-center justify-content-center mb-4">
											<Col lg={5} md={5} xs={12} style={{ marginBottom: "10px" }}>
												<Input
													value={searchTitle}
													style={{ width: "100%", borderRadius: "20px", padding: "8px 15px", transition: "all 0.3s ease", border: "1px solid #d9d9d9" }}
													onFocus={(e) => e.target.style.boxShadow = "0 0 0 3px rgba(7,88,143,0.1)"}
													onBlur={(e) => e.target.style.boxShadow = "none"}
													onChange={(e) => setSearchTitle(e.target.value)}
													placeholder="Search by Title"
												/>
											</Col>
											<Col lg={2} md={2} xs={4} style={{ marginBottom: "10px" }}>
												<Dropdown overlay={orderMenu} trigger={['click']}>
													<AntButton
														style={{ width: "100%", borderRadius: "20px", padding: "0 15px", height: "36px", transition: "all 0.3s ease" }}
														onMouseEnter={(e) => { e.currentTarget.style.borderColor = "#07588f"; e.currentTarget.style.color = "#07588f"; }}
														onMouseLeave={(e) => { e.currentTarget.style.borderColor = "#d9d9d9"; e.currentTarget.style.color = "rgba(0,0,0,0.85)"; }}
													>
														Sort: {selectedOrder} ▼
													</AntButton>
												</Dropdown>
											</Col>
											<Col lg={3} md={3} xs={8} style={{ marginBottom: "10px", display: "flex", gap: "8px" }}>
												<AntButton
													style={{ background: "#07588f", color: "#fff", border: "none", flex: 1, borderRadius: "20px", height: "36px", transition: "all 0.3s ease" }}
													onMouseEnter={(e) => { e.currentTarget.style.background = "#0a6ebd"; e.currentTarget.style.transform = "translateY(-2px)"; e.currentTarget.style.boxShadow = "0 4px 12px rgba(7,88,143,0.3)"; }}
													onMouseLeave={(e) => { e.currentTarget.style.background = "#07588f"; e.currentTarget.style.transform = "translateY(0)"; e.currentTarget.style.boxShadow = "none"; }}
													onClick={() => filterWebinarsEvents()}
												>
													Search
												</AntButton>
												<AntButton
													style={{ flex: 1, borderRadius: "20px", height: "36px", transition: "all 0.3s ease" }}
													onMouseEnter={(e) => { e.currentTarget.style.borderColor = "#07588f"; e.currentTarget.style.color = "#07588f"; e.currentTarget.style.transform = "translateY(-2px)"; }}
													onMouseLeave={(e) => { e.currentTarget.style.borderColor = "#d9d9d9"; e.currentTarget.style.color = "rgba(0,0,0,0.85)"; e.currentTarget.style.transform = "translateY(0)"; }}
													onClick={clearSearch}
												>
													Clear
												</AntButton>
											</Col>
										</Row>
									</Col>

									<div className="tabs">
										<h5
											className={`tab-button ${activeTab === 'Upcoming' ? 'active' : ''}`}
											onClick={() => setActiveTab('Upcoming')}
										>
											Upcoming
										</h5>
										<h5
											className={`tab-button ${activeTab === 'Archived' ? 'active' : ''}`}
											onClick={() => setActiveTab('Archived')}
										>
											Archived
										</h5>
									</div>

									{isLoading ?
										<Box sx={{ my: '5rem' }}>
											<LinearProgress color="success" />
										</Box>
										:
										paginatedData.map((e, index) => {
											return <>
												<Col xl={6} xxl={4} lg={6} md={6} sx={12} style={{ marginBottom: "20px" }}>
													<Card
														className="cards"
														style={{
															transition: "transform 0.3s ease, box-shadow 0.3s ease",
															animation: `fadeInUp 0.5s ease ${index * 0.1}s both`
														}}
														onMouseEnter={(ev) => {
															ev.currentTarget.style.transform = "translateY(-5px)";
															ev.currentTarget.style.boxShadow = "0 10px 30px rgba(0,0,0,0.12)";
														}}
														onMouseLeave={(ev) => {
															ev.currentTarget.style.transform = "translateY(0)";
															ev.currentTarget.style.boxShadow = "";
														}}
													>
														<CustomTextLimit limit={50} title text={e.title} />
														<CustomTextLimit text={e.description} />
														<img
															src={e.image}
															height="200px"
															loading="lazy"
															width="100%"
															style={{ objectFit: "cover", transition: "transform 0.3s ease" }}
															onMouseEnter={(ev) => ev.currentTarget.style.transform = "scale(1.03)"}
															onMouseLeave={(ev) => ev.currentTarget.style.transform = "scale(1)"}
														/>

														<div className="card-content">
															<div>
																<h6 className="bold">Date: </h6>
																<h6>{moment(e?.date).format("DD-MM-YYYY")}</h6>
															</div>
															{activeTab === "Upcoming" ?
																<Button onClick={() => window.open(e?.url?.startsWith('http') ? e.url : `https://${e.url}`, '_blank')} disabled={!e?.url} className="card_btn" variant="primary">Register</Button>
																:
																<Button onClick={() => { setModalShow(true); setVideoUrl(e?.url) }} disabled={!e?.url || !e?.url.includes("youtu")} className="card_btn" variant="primary">Watch Video</Button>
															}
														</div>
													</Card>
												</Col>
											</>
										})}
								</Row>
							</Container>
							<Pagination
								total={data.length}
								current={currentPage}
								pageSize={pageSize}
								hideOnSinglePage
								onChange={(page) => setCurrentPage(page)} />


							<Modal backdrop="static"
								centered
								dialogClassName="modal-90w"
								keyboard={false}
								show={modalShow}
								onHide={() => setModalShow(false)}
								aria-labelledby="contained-modal-title-vcenter">
								<Modal.Header className="modal-bg" closeButton>
									<Modal.Title id="contained-modal-title-vcenter">
										Video
									</Modal.Title>
								</Modal.Header>
								<Modal.Body className="grid-example modal-bg">
									<Container>

										{/* <Row>
												<Col xs={12} md={12}> */}

										<ReactPlayer controls url={cleanYoutubeUrl(videoUrl)} width="100%" style={{ minHeight: "60vh", maxHeight: "80vh" }} />

										{/* </Col>

												
											</Row> */}


									</Container>
								</Modal.Body>
							</Modal>
						</div>
					</div>
				</section>


			</div>
		</>
	);
};

export default WebinarsandEvents;
